import React, { Component } from 'react'
import { checkTranslation, chooseFontColor, conditionalWidth, imageAddress, translate } from '../../utils/useful'
import NotificationsMenu from './NotificationsMenu'
import Responsive from '../Responsive'
import SelectApplet_ from '../useful/SelectApplet_'


export default class HeaderPortal extends Component {
    state = {
        bg: 'linear-gradient(90deg, #347f00, #42c200)',
        collapses: {},

    }
    componentDidMount() {

    }

    changeCollapse = () => {
        let main = this.state.main
        this.setState({ main: !main })
    }

    changeNav = (type, id) => {
        // console.log(id)
        this.props.changeNav(type, id)

    }


    render() {

        let title = this.props?.config?.title
        if (title == '') {
            title = null
        }

        let type = this.props.applet?.type

        if (!type && Array.isArray(this.props.applet?.features)) {
            type = this.props.applet.features[0]
        }

        let primaryColor = this.props.colors?.primaryColor ?? '#505050'
        let secondaryColor = this.props.colors?.secondaryColor ?? '#696969'

        let background = `linear-gradient(90deg, ${primaryColor}, ${secondaryColor})`


        return (
            <div className='w-100'>
                <div className={' w-100 flexcc flex-column ' + (' window-content-radius-top')} style={{ zIndex: 1, background: background }}>

                    {/* <HeaderInformation config={this.props?.config} hub={this.props.hub} setHeader={this.props.setHeader} backActionMobile={this.props.backActionMobile} headertype={this.props.headertype} username={this.props.username} changePage={this.props.changePage} addToCart={this.props.addToCart} types={this.props.types} cart={this.props.cart} functionsHandler={this.props.functionsHandler} showSettings={this.props.showSettings} colors={this.props.colors} showHome={this.props.showHome} title={title} applet={this.props.applet} page={this.props.page} width={this.props.width} backbtn={this.props.backbtn} backStage={this.props.backStage} goToHub={this.props.goToHub} changeWindow={this.props.changeWindow} changeWindowLink={this.props.changeWindowLink} data={this.props.data} variables={this.props.variables} sections={this.props.sections} modules={this.props.modules} frames={this.props.frames} addNewWindow={this.props.addNewWindow} /> */}

                    <div className={' w-100 p-2 flexcb'}>
                        <div className='flexc flex-1 w-100' style={{ minWidth: 0 }}>
                            {this.props.config?.backAction && (
                                <button className='flexc' onClick={() => this.props.config?.backAction()}>
                                    <img width={30} src="/assets/icons/back-white.svg" />
                                </button>
                            )}

                            <button onClick={() => this.props.changePage()} className='mrd-3 flexcc' style={{ position: 'relative', }} >
                                <img className="br-50" src={this.props.portalImage} style={{ width: 36, height: 36, objectFit: 'cover', border: '2px solid #ffffff90' }} alt='' />
                            </button>

                            {this.props.config?.headerIdentityComponent ? (
                                <div className='flexc w-100'>

                                    <div className=' flexc' style={{ justifyContent: conditionalWidth(this.props.width, { xs: 'flex-end', sm: 'start' }) }}>
                                        {this.props.config?.headerIdentityComponent()}
                                    </div>
                                </div>
                            ) : (

                                <Responsive width={this.props.width} media={{ xs: 'auto', 600: 'auto' }}>
                                    <button className='flexc' onClick={() => this.props.changePage()} >
                                        <p className=' text-semibig text-semibold' style={{ whiteSpace: "nowrap", color: '#fff' }} >{this.props.portalName}</p>
                                    </button>

                                </Responsive>
                            )}

                            {this.props.currentHub && (
                                <div className='flex-1 px-2 flexc' style={{ minWidth: 0 }} >
                                    <div className='br-30  px-1 py-1 flexc scroll-no-scrollbar' style={{ overflow: 'auto', backgroundColor: '#ffffff00', border: '1px solid #ffffff40' }}>
                                        <button className='mrd-2 flexcc' style={{ position: 'relative', }} onClick={() => this.props.changePage()}>
                                            <img className="br-50" src='/assets/icons/portals/files.png' style={{ width: 18, height: 18, objectFit: 'cover', border: '2px solid #ffffff90' }} alt='' />
                                        </button>

                                        {this.props.currentHub && (
                                            <>
                                                <div className='mrd-0 flexcc'>
                                                    <img src='/assets/icons/arrow-right-white.svg' height={16} alt='' />
                                                </div>
                                                <button className='br-30  pld-2 prd-4 py-1 flexc' onClick={() => this.changeNav('hub', this.props.currentHub?.username)} style={{ backgroundColor: '#00000020' }}>
                                                    <img className="br-50 mrd-1" src={imageAddress(this.props.currentHub?.image, 'hub', 'thumb')} style={{ width: 18, height: 18, objectFit: 'cover', border: '2px solid #ffffff90' }} alt='' />

                                                    <p className='white text-smaller text-semibold no-wrap'>{this.props.currentHub.fullname}</p>
                                                </button>
                                            </>
                                        )}

                                        {this.props.currentApplet && (
                                            <>
                                                <div className='mrd-0 flexcc mld-0 opacity-5'>
                                                    <img src='/assets/icons/arrow-right-white.svg' height={16} alt='' />
                                                </div>
                                                <button className='br-30  pld-2 prd-4 py-1 flexc' onClick={() => this.changeNav('applet', this.props.currentApplet?._id)} style={{ backgroundColor: '#00000020' }}>
                                                    <img className="br-50 mrd-1" src={imageAddress(this.props.currentApplet?.image, 'hub', 'thumb')} style={{ width: 18, height: 18, objectFit: 'cover', border: '2px solid #ffffff90' }} alt='' />

                                                    <p className='white text-smaller text-semibold no-wrap'>{checkTranslation(this.props.currentApplet.name)}</p>
                                                </button>
                                            </>
                                        )}

                                        {this.props.currentFrame && (
                                            <>
                                                <div className='mrd-0 flexcc mld-0 opacity-5'>
                                                    <img src='/assets/icons/arrow-right-white.svg' height={16} alt='' />
                                                </div>
                                                <button className='br-30  pld-2 prd-4 py-1 flexc' onClick={() => this.changeNav('frame', this.props.currentFrame?._id)} style={{ backgroundColor: '#00000020' }}>
                                                    <img className="br-50 mrd-1" src={imageAddress(this.props.currentFrame?.image, 'hub', 'thumb')} style={{ width: 18, height: 18, objectFit: 'cover', border: '2px solid #ffffff90' }} alt='' />

                                                    <p className='white text-smaller text-semibold no-wrap'>{checkTranslation(this.props.currentFrame.name)}</p>
                                                </button>
                                            </>
                                        )}

                                        {(this.props.config?.paths && (this.props.config?.viewType == null || this.props.config?.viewType?.key == 'explore')) && (
                                            <div className="flexcc" style={{ justifyContent: 'left', width: `calc(100% - ${this.state.profileImageWidth + this.state.profileTextWidth}px)` }}>
                                                {Array.isArray(this.props.config.paths) && this.props.config.paths.length > 0 && (
                                                    <>
                                                        {this.props.config.paths.map((nav, j) => {
                                                            return (
                                                                <>
                                                                    <div className='mrd-0 flexcc mld-0 opacity-5'>
                                                                        {/* <p className='white opacity-5'>/</p> */}
                                                                        <img src='/assets/icons/arrow-right-white.svg' height={16} alt='' />
                                                                    </div>
                                                                    <button onClick={() => this.changeNav('folder', nav.link)} className='br-30  prd-4 pld-4  py-1 flexc' style={{ backgroundColor: '#00000020' }}>
                                                                        {/* <img className="br-50 mrd-1" src={imageAddress(this.props.currentFrame?.image, 'hub', 'thumb')} style={{ width: 18, height: 18, objectFit: 'cover', border: '2px solid #ffffff90' }} alt='' /> */}

                                                                        <p className='white text-smaller text-semibold no-wrap'>{checkTranslation(nav.name)}</p>
                                                                    </button>
                                                                </>
                                                            )
                                                        })}
                                                    </>
                                                )}
                                            </div>
                                        )}


                                    </div>
                                </div>
                            )}

                        </div>

                        <div className='flexcc'>
                            {this.props.config?.topHeaderComponent && (
                                <div className=' flexc' style={{ justifyContent: conditionalWidth(this.props.width, { xs: 'flex-end', sm: 'start' }) }}>
                                    {this.props.config?.topHeaderComponent()}
                                </div>
                            )}

                            <NotificationsMenu language={this.props.language} hub={this.props.hub} variables={this.props.variables} width={this.props.width} colors={this.props.colors} applet={this.props.applet} features={this.props.features} page={this.props.page} changeWindow={this.props.changeWindow} sections={this.props.sections} modules={this.props.modules} frames={this.props.frames} addNewWindow={this.props.addNewWindow} />
                        </div>

                    </div>
                    {this.props.config?.showToolbar == true && (
                        <div className='flexcb w-100  sc-2 px-2' style={{ background: this.props.colors?.iconInvert ? 'rgba(40, 40, 40, 0.08)' : 'rgba(255, 255, 255, 0.08)', overflowX: 'auto', height: '46px' }}>
                            <div className='flexc w-100'>


                                {/* {(this.props.config.showFrames == 'static' || this.props.config.showFrames == true) && (
                                    <StaticFrame language={this.props.language} width={this.props.width} userPerspective={this.props.userPerspective} sections={this.props.sections} modules={this.props.modules} changePage={this.props.changePage} functionsHandler={this.props.functionsHandler} colors={this.props.colors} frames={this.props.frames} variables={this.props.variables} updateFrames={this.props.updateFrames} />
                                )} */}

                                {/* {this.props.config.showFrames == 'desk' && (
                                    <DeskFrame permissions={this.props.permissions} language={this.props.language} width={this.props.width} userPerspective={this.props.userPerspective} sections={this.props.sections} modules={this.props.modules} changePage={this.props.changePage} functionsHandler={this.props.functionsHandler} colors={this.props.colors} frames={this.props.config.frames} />
                                )} */}

                                {/* {this.props.config.showFrames == 'booking' && (
                                    <BookingFrame language={this.props.language} width={this.props.width} userPerspective={this.props.userPerspective} applet={this.props.applet} user={this.props.user} tabIndex={this.props.tabIndex} functionsHandler={this.props.functionsHandler} colors={this.props.colors} setData={this.props.setData} />
                                )} */}

                                {/* {this.props.config.showFrames == 'inquery' && (
                                    <InqueriesFrame language={this.props.language} width={this.props.width} userPerspective={this.props.userPerspective} sections={this.props.sections} list={this.props.list} modules={this.props.modules} changePage={this.props.changePage} functionsHandler={this.props.functionsHandler} colors={this.props.colors} addNewForm={this.props.addNewForm} />
                                )} */}
                                {/* {this.props.config.showFrames == 'applet' && (
                                    <DynamicFrame language={this.props.language} width={this.props.width} userPerspective={this.props.userPerspective} sections={this.props.sections} modules={this.props.modules} changePage={this.props.changePage} functionsHandler={this.props.functionsHandler} colors={this.props.colors} />
                                )} */}
                                {/* {this.props.config.showFrames == 'settings' && (
                                    <SettingFrame width={this.props.width} userPerspective={this.props.userPerspective} sections={this.props.sections} modules={this.props.modules} settings={this.props.settings} settingsSections={this.props.settingsSections} changePage={this.props.changePage} functionsHandler={this.props.functionsHandler} colors={this.props.colors} />
                                )} */}

                                {/* {this.props.config.showFrames == 'email' && (
                                    <EmailFrame accounts={this.props.accounts} userPerspective={this.props.userPerspective} width={this.props.width} sections={this.props.sections} modules={this.props.modules} changePage={this.props.changePage} functionsHandler={this.props.functionsHandler} colors={this.props.colors} />
                                )} */}
                                {/* {this.props.config.showFrames == 'dashboardsSettings' && (
                                    <DashboardsSettingsFrame language={this.props.language} width={this.props.width} userPerspective={this.props.userPerspective} sections={this.props.sections} list={this.props.list} modules={this.props.modules} changePage={this.props.changePage} functionsHandler={this.props.functionsHandler} colors={this.props.colors} addNewForm={this.props.addNewForm} />
                                )} */}
                                {/* <button className='mrd-2 flexcc dark-blur-hover px-2 br-5 py-1' ref={el => this.view = el} onClick={() => { this.viewView.showView() }}>
                                        <p className='white font-size-13'>{translate('Views')}</p>
                                        <div className='br-20 mld-1 flexcc' style={{ color: this.props.color ?? '#000', backgroundColor: 'rgba(255, 255, 255, 0.1)', height: 20, minWidth: 20 }}>
                                            <p className='text-smaller text-semibold white'>3</p>
                                        </div>
                                    </button>
                                    <DataMenu color={this.props.color} language={this.props.language} width={this.props.width} />
                                    <ToolsMenu language={this.props.language} width={this.props.width} /> */}

                                {this.props.config?.toolbar && (
                                    this.props.config.toolbar()
                                )}

                                {/* {this.props.toolbarView == 'applet' &&
                                    <CollectionToolbar functionsHandler={this.props.functionsHandler} color={this.props.color} language={this.props.language} width={this.props.width} />
                                }

                                {this.props.toolbarView == 'email' &&
                                    <EmailToolbar functionsHandler={this.props.functionsHandler} showCheckBox={this.props.showCheckBox} checkBox={this.props.checkBox} sections={this.props.sections} modules={this.props.modules} changePage={this.props.changePage} color={this.props.color} language={this.props.language} width={this.props.width} />
                                } */}

                            </div>

                            {/* {this.props.toolbarView == 'settings' &&
                                <div className='flexc'>
                                    <SettingFrame width={this.props.width} sections={this.props.sections} modules={this.props.modules} settings={this.props.settings} settingsSections={this.props.settingsSections} changePage={this.props.changePage} />
                                    <DataMenu language={this.props.language} width={this.props.width} />
                                    <ToolsMenu language={this.props.language} width={this.props.width} />
                                </div>
                            } */}



                        </div>
                    )}
                </div>

                {/* <FixedView width={this.props.width} zIndex={10} ref={el => this.viewView = el} nodeRef={this.view} xOffset={this.props.language == 'fa' ? 175 : -10} bottomOffset={0} topOffset={0} maxWidth={260} >
                    <div className='bg-white br-10 p-1 shadow-3'>
                        <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}>
                            <div width={this.props.width} isLoading={this.props.isLoading} stage={0} stageName={'view'} className=' p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'auto', }}>
                                <div className='mb-2'>
                                    <IntractionActionsList language={this.props.language} onClick={this.changePageSubMenu} data={{ title: "{{lang}}header.Views List", icon: "/assets/icons/note/view/mode.svg" }} />
                                </div>
                                <div className='pt-2' style={{ borderTop: "1px solid #eee" }}>
                                    <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}header.Add View", check: true }} />
                                </div>
                            </div>
                        </StagesManager>
                    </div>
                </FixedView> */}
            </div>

        )
    }
}
